App.factory('dataUser', ['$rootScope', '$state', 'profileService', function($rootScope, $state, profileService) {
    function DataUser() {
        var self = this;
        // this.check = function() {
        // 	var data = JSON.parse(window.sessionStorage.getItem('userObject'));

        //     if (!data.firstName.length || !data.lastName.length || !data.identifier.length) {
	       //      $rootScope.__validDataUser = false;
	       //  } else {
	       //      $rootScope.__validDataUser = true;
	       //  }
        // }

        self.get = function() {
            profileService.dataUser().then(function(data) {
                if (data.status === 200) {
                    return data.data;
                }
            });
        };

        self.getLocal = function() {
            return window.sessionStorage.getItem('userObject');
        };

        self.updatePromise = function () {
            return profileService.dataUser();
        };

        self.updateUserDataLocally = function (data, person, withRedirect, stateParams) {
            if (data.status === 200) {
                var userData = data.data;
                userData.person = person;
                window.sessionStorage.setItem('userObject', JSON.stringify(userData));
                $rootScope.__logged = true;
                $rootScope.__rights = userData.rights;

                let arrayRights = ['ADMIN', 'ZOCHA'];
                for (let i = 0; i < arrayRights.length; i++) {
                    if (userData.rights.indexOf(arrayRights[i]) > -1) {
                        $rootScope.__isAccess = true;
                    }
                }
                let insurerArrayRights = ['ADMIN', 'INSURER'];
                for (let i = 0; i < insurerArrayRights.length; i++) {
                    if (userData.rights.indexOf(insurerArrayRights[i]) > -1) {
                        $rootScope.__isInsurer = true;
                    }
                }
            } else if (data.data.error === 'invalid_token') {
                self.clearSession();
            }

            if (withRedirect) {
                var redirectLocation = $rootScope.CONFIGURATOR.register.routeToRedirect;
                if (stateParams.redirectToThirdStep && redirectLocation) {
                    redirectLocation = stateParams.redirectLocation;
                }
                $state.go(redirectLocation, {
                    person: stateParams.person,
                    persons: stateParams.persons,
                    choose: stateParams.choose,
                    prices: stateParams.prices,
                    summary: stateParams.summary,
                }, {
                    inherit: false
                });
            }
        };

        self.update = function(withRedirect, stateParams) {
            profileService.dataUser().then(function(data) {
                self.getPerson(data, withRedirect, stateParams);
            });
        }

        self.getPerson = function(data, withRedirect, stateParams) {
            profileService.dataPerson().then(function(person) {
                self.updateUserDataLocally(data, person.data, withRedirect, stateParams);
            });
        }

        self.refreshInfo = function() {
            var userData = JSON.parse(window.sessionStorage.getItem('userObject'));
            var isLogged = window.sessionStorage.getItem('isLogged');
            var reg = isLogged === undefined || isLogged === null || isLogged.length == 0;

            if (!reg) {
                $rootScope.__logged = true;
            }

            if (userData) {
                $rootScope.__rights = userData.rights;

                let arrayRights = ['ADMIN', 'ZOCHA'];
                for (let a = 0; a < arrayRights.length; a++) {
                    if (userData.rights.indexOf(arrayRights[a]) > -1) {
                        $rootScope.__isAccess = true;
                    }
                }

                let insurerArrayRights = ['ADMIN', 'INSURER'];
                for (let i = 0; i < insurerArrayRights.length; i++) {
                    if (userData.rights.indexOf(insurerArrayRights[i]) > -1) {
                        $rootScope.__isInsurer = true;
                    }
                }
            }
        };

        self.clearSession = function() {
            window.sessionStorage.removeItem('isLogged');
            window.sessionStorage.removeItem('refresh_token');
            window.sessionStorage.removeItem('params');
            window.sessionStorage.removeItem('userObject');
            $rootScope.__logged = false;
            $rootScope.__isAccess = false;
            $rootScope.__isInsurer = false;
        }
    }
    
    return new DataUser();
}]);
